import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../helpers/axiosConfig';

export const fetchSubcategories = createAsyncThunk(
  'subcategories/fetchSubcategories',
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/subcategories/${categoryId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch subcategories'
      );
    }
  }
);

const initialState = {
  subcategories: [],
  loading: false,
  error: null,
};

const subcategoriesSlice = createSlice({
  name: 'subcategories',
  initialState,
  reducers: {
    clearSubcategories: (state) => {
      state.subcategories = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubcategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubcategories.fulfilled, (state, action) => {
        state.loading = false;
        state.subcategories = action.payload.subcategories;
      })
      .addCase(fetchSubcategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSubcategories } = subcategoriesSlice.actions;
export default subcategoriesSlice.reducer;
